module.exports = __webpack_public_path__ + "static/media/whatsapp_full.0967bb6788737c39697294b2329213e6.svg";